// ─── Logger utility ────────────────────────────────────────────────────────────
// Structured logging with log levels. In production only errors are emitted.

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LOG_LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

const configuredLevel = (process.env.REACT_APP_LOG_LEVEL as LogLevel) ?? 'info';

function shouldLog(level: LogLevel): boolean {
  return LOG_LEVELS[level] >= LOG_LEVELS[configuredLevel];
}

function formatMessage(level: LogLevel, message: string, context?: unknown): string {
  const ts = new Date().toISOString();
  return `[${ts}] [${level.toUpperCase()}] ${message}${context ? ' ' + JSON.stringify(context) : ''}`;
}

const logger = {
  debug(message: string, context?: unknown): void {
    if (shouldLog('debug')) {
      console.debug(formatMessage('debug', message, context));
    }
  },
  info(message: string, context?: unknown): void {
    if (shouldLog('info')) {
      console.info(formatMessage('info', message, context));
    }
  },
  warn(message: string, context?: unknown): void {
    if (shouldLog('warn')) {
      console.warn(formatMessage('warn', message, context));
    }
  },
  error(message: string, context?: unknown): void {
    if (shouldLog('error')) {
      console.error(formatMessage('error', message, context));
    }
  },
};

export default logger;
